export default "__VITE_ASSET__032767a3__"